<template>
  <!-- The warehouse pages' messages (useWarehouse().showSnackbar) — saved,
       refused, "nothing to download this month". Rendered once here, on every
       page: the bar that showed them was dropped in May 2026 when the
       warehouse views were split up, and since then every one of these
       messages went nowhere (found 2026-10-08: "Catering PDF doesn't open"). -->
  <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="5000">
    {{ snackbarText }}
    <template v-slot:actions>
      <v-btn variant="text" @click="snackbar = false">Close</v-btn>
    </template>
  </v-snackbar>
</template>

<script setup>
import { useWarehouse } from "@/composables/useWarehouse.js";

const { snackbar, snackbarText, snackbarColor } = useWarehouse();
</script>
